import {
  specialityRequestSlice
} from "../../reducers/reservation/specialityReducer";

export const { updateSpecialityRequest, resetSpecialityRequest } =
specialityRequestSlice.actions;
